import type { CategoryId } from '@atlassian/jira-servicedesk-knowledge-services/src/types.tsx';

export const CLEAR_BROWSE = 'state.actions.clear-browse.CLEAR_BROWSE' as const;

export type ClearBrowseAction = {
	type: typeof CLEAR_BROWSE;
	payload: CategoryId;
};

export const clearBrowse = (categoryId: CategoryId): ClearBrowseAction => ({
	type: CLEAR_BROWSE,
	payload: categoryId,
});
